import { Box, CircularProgress } from "@mui/material";

export default function LoaderComponent() {
  return (
    <Box
    sx={{
        position: "absolute",
        inset: 0,
        backgroundColor: "rgba(255,255,255,0.6)",
        zIndex: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress size={55} thickness={4}  />
    </Box>
  )
}
